import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import MovieSearchTextDisplay from './MovieSearchTextDisplay'


const MovieSearchLinkWithRouter = ({
    isSearchToggle,
    searchLinkClass,
    iconThin,
    translation,
}) => {
    const location = useLocation()
    let queryStringValues = queryString.parse(location.search)
    let active = queryStringValues.search

    if(isSearchToggle && queryStringValues.searchopen) {
        if('1' === queryStringValues.searchopen) {
            queryStringValues.searchopen = 0
            delete queryStringValues.search
        } else {
            queryStringValues.searchopen = 1
        }
    } else {
        queryStringValues.searchopen = 1
    }

    return (
        <Link
            className={"search-link" + (searchLinkClass ? ' ' + searchLinkClass : '') + (active ? ' filter-active accent-color-font' : '')}
            to={{
                search: queryString.stringify(queryStringValues)
            }}
        >
            <MovieSearchTextDisplay
                iconThin={iconThin}
                translation={translation}
            />
        </Link>
    )
}

export default MovieSearchLinkWithRouter